export default __webpack_public_path__ + "static/media/File No. 6.f3f943ed.pdf";